"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _oxygenConstants = require("@8x8/oxygen-constants");

var getBackgroundColor = function getBackgroundColor(_ref) {
  var theme = _ref.theme,
      type = _ref.type;
  return type === _oxygenConstants.toastTypes.error ? theme.backgroundColorError : theme.backgroundColor;
};

var _default = getBackgroundColor;
exports["default"] = _default;